import { AdManager } from './AdManager';
import { AD_CONFIG } from './adConfig';
import { EventBus } from '../core/events/EventBus';

export class InterstitialAd {
  private static SKIP_DELAY_MS = 4000; // 4 saniye geri sayım

  /**
   * Tam ekran reklam overlay'ini göster.
   * 4 saniye sonra Skip butonu aktif olur.
   * Kullanıcı reklamı geçince Promise çözümlenir ve oyun başlar.
   */
  static show(gameId: string): Promise<void> {
    return new Promise((resolve) => {
      // Eğer zaten bir reklam açıksa kapat, yenisini açma (çift tıklamayı önler)
      const existingOverlay = document.querySelector('.ad-interstitial-overlay');
      if (existingOverlay) {
        existingOverlay.remove();
      }

      EventBus.emit('ad:interstitialShown', { gameId });

      // Dev modundaysak veya yerel geliştirme yapıyorsak hızlı simülasyon göster
      const overlay = this.createOverlay(gameId);
      document.body.appendChild(overlay);

      AdManager.pushAd();

      const skipBtn = overlay.querySelector<HTMLButtonElement>('#ad-skip-btn')!;
      const timerSpan = overlay.querySelector<HTMLSpanElement>('#ad-timer-count')!;

      let remaining = 4;
      const countdownInterval = setInterval(() => {
        remaining -= 1;
        if (remaining > 0) {
          if (timerSpan) timerSpan.textContent = `${remaining}s`;
        } else {
          clearInterval(countdownInterval);
          skipBtn.disabled = false;
          skipBtn.classList.add('ad-skip--active');
          skipBtn.innerHTML = 'Reklamı Geç &rsaquo;';
        }
      }, 1000);

      const closeAd = () => {
        if (skipBtn.disabled) return;
        skipBtn.disabled = true; // prevent double clicks during fade out
        clearInterval(countdownInterval);
        overlay.classList.add('ad-interstitial--fade-out');
        setTimeout(() => {
          overlay.remove();
          EventBus.emit('ad:interstitialClosed', { gameId });
          resolve();
        }, 300);
      };

      skipBtn.addEventListener('click', closeAd);
    });
  }

  private static createOverlay(gameId: string): HTMLElement {
    const div = document.createElement('div');
    div.className = 'ad-interstitial-overlay';
    div.innerHTML = `
      <div class="ad-interstitial__container">
        <div class="ad-interstitial__header">
          <span class="ad-interstitial__badge">Sponsorlu Reklam</span>
          <span class="ad-interstitial__title">Oyun Hazırlanıyor...</span>
        </div>
        <div class="ad-interstitial__content">
          <ins class="adsbygoogle"
               style="display:block; width:100%; height:300px;"
               data-ad-client="${AD_CONFIG.clientId}"
               data-ad-slot="${AD_CONFIG.interstitialSlot}"
               data-ad-format="auto"
               data-full-width-responsive="true"></ins>
          <div class="ad-interstitial__placeholder">
            <div class="ad-placeholder__icon">🎮</div>
            <h3>Arcade Portal</h3>
            <p>Oyununuz yüklenirken sponsor reklamını görüntülüyorsunuz.</p>
          </div>
        </div>
        <div class="ad-interstitial__footer">
          <div class="ad-interstitial__timer-box">
            <button id="ad-skip-btn" class="ad-skip" disabled>
              ⏳ <span id="ad-timer-count">4s</span> sonra reklamı geçebilirsiniz
            </button>
          </div>
        </div>
      </div>
    `;
    return div;
  }
}
